import React, { Fragment } from 'react';

import * as Actions from 'exchange/components/list/actions';

const ExchangeActions = ({ permissions, exchange, company, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.exchanges.update'] && (
        <Actions.Edit exchange={exchange} company={company} />
      )}
    </Fragment>
  );
};

export default ExchangeActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/list/ExchangeActions.js